import React from 'react';
import { List } from '@mui/material';
import { TallyCompany } from '../../../../types/tally';
import TallyCompanyListItem from './TallyCompanyListItem';

interface TallyCompanyListProps {
  companies: TallyCompany[];
  onFetchDetails: (company: TallyCompany) => void;
  onAddCompany: (company: TallyCompany) => void;
  onEditGst: (companyName: string) => void;
  onSaveGst: (companyName: string) => void;
  onCancelEditGst: (companyName: string) => void;
  onGstChange: (companyName: string, value: string) => void;
  onFetchVendorDetails: (companyName: string) => void;
  onDownloadCorruptedVendors: (companyName: string) => void;
}

const TallyCompanyList: React.FC<TallyCompanyListProps> = props => {
  return (
    <List>
      {props.companies.map(company => (
        <TallyCompanyListItem key={company.name} company={company} {...props} />
      ))}
    </List>
  );
};

export default TallyCompanyList;
